import { productsAdapter } from "../adapters/products-adapter";
import { ProductsResource } from "../resources/products-resource";
import { ClientProducts } from "../types/products";

export const ProductsRepository = {
  async fetchProducts(): Promise<ClientProducts[]> {
    const options = await ProductsResource.getProducts();
    return productsAdapter.toClientProducts(options);
  },
};
